module.exports = __webpack_public_path__ + "static/media/search.f052f257.svg";